module.exports = __webpack_public_path__ + "img/audi-a4.84dccc36.jpg";